// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sgf-ace.completion-view[data-v-4c7d9828]{text-align:center}.sgf-ace .completion-view__toast[data-v-4c7d9828]{font-size:2em;font-weight:700;padding-bottom:25px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
